module.exports = __webpack_public_path__ + "static/044-212733fa8967962ca99fedfa8b226d0d.jpg";